import { useTranslation } from 'react-i18next'

import { TutorialStatus, useTutorialStore } from '@wwt/core/tutorial'
import { Offer } from '@wwt/entities/search-response'

import { useOfferReaction } from '@/entities/offer'

export const useOfferCardFooter = (offer: Offer) => {
	const { t } = useTranslation()

	const {
		isLiked,
		isDisliked,
		handleDislike: handleDislikeReaction,
		handleLike: handleLikeReaction
	} = useOfferReaction(offer)

	const tutorialStatus = useTutorialStore.use.tutorialStatus()

	const canExecuteAction = tutorialStatus !== TutorialStatus.GOING

	const onLike = () => {
		if (!canExecuteAction) return

		handleLikeReaction()
	}

	const onDislike = () => {
		if (!canExecuteAction) return

		handleDislikeReaction()
	}

	return {
		price: t('price.base', {
			value: offer.price.totalPrice(true)
		}),
		isLiked,
		isDisliked,
		onLike,
		onDislike
	}
}
